var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from "react";
import { Row } from "react-bootstrap";
import Loading from "@irati/ui/src/Loading";
import authentication from "@irati/auth";
import mfaService from "@irati/auth/services/mfa";
import { ButtonRouterLink } from "@irati/ui/src/Link";
import Flex from "@irati/ui/src/Flex";
import teamService from "@irati/identity/services/teams";
import addOrRemoveFromArray from "@irati/utils/addOrRemoveFromArray";
import YouNeedToMfa from "@irati-web/mfa/components/Error/YouNeedToMfa";
import { FormattedMessage } from "@irati/utils/lang";
import BusinessAdminHeader from "../../../components/AdminHeader/BusinessAdminHeader";
import ManageUsersBottomBar from "../../../components/Users/ManageUsersBottomBar";
import UserList from "../../../components/Users/UserList/UserList";
import { FILTER_OPTIONS } from "../../../constants/filter";
import UserListData from "../../../components/UserList";
import { ADD_PEOPLE_MULTIPLE, ADD_PEOPLE_SINGLE } from "../../../routes/routeConfig";
var ManageUsers = /** @class */ (function (_super) {
    __extends(ManageUsers, _super);
    function ManageUsers(props) {
        var _this = _super.call(this, props) || this;
        _this.userList = React.createRef();
        _this.handleMFARetry = function () {
            _this.setState({ mfaLoad: mfaService.hasFlag() });
        };
        _this.getTeams = function () {
            return teamService.list(authentication.userTenant().uuid).then(function (teams) {
                _this.setState({ teams: teams });
            });
        };
        _this.toggleSelectedUsers = function (user) {
            _this.setState(function (state) {
                var selectedEmployees = state.selectedEmployees;
                var arr = addOrRemoveFromArray(selectedEmployees, user, function (a, b) { return a.uuid === b.uuid; });
                return {
                    selectedEmployees: arr
                };
            });
        };
        _this.handleAddPeopleSubmit = function () {
            if (_this.userList.current) {
                _this.userList.current.refetch();
            }
        };
        _this.handleActivationStatusChange = function () {
            _this.setState({ selectedEmployees: [] });
        };
        _this.state = {
            selectedEmployees: [],
            isAddToTeamPopUpOpen: false,
            mfaLoad: mfaService.hasFlag(),
            teams: []
        };
        return _this;
    }
    ManageUsers.prototype.componentDidMount = function () {
        this.getTeams();
    };
    ManageUsers.prototype.render = function () {
        var _this = this;
        var _a = this.state, selectedEmployees = _a.selectedEmployees, mfaLoad = _a.mfaLoad, teams = _a.teams;
        return (React.createElement(Loading, { load: mfaLoad, Error: function () { return React.createElement(YouNeedToMfa, { onRetry: _this.handleMFARetry }); } },
            React.createElement(Row, null,
                React.createElement(React.Fragment, null,
                    React.createElement(BusinessAdminHeader, null,
                        React.createElement(Flex, { alignItems: "center", justifyContent: "flex-end" },
                            React.createElement(ButtonRouterLink, { primary: true, to: ADD_PEOPLE_SINGLE, marginRight: 2 },
                                React.createElement(FormattedMessage, { id: "admin.manageUsers.button.addOnePerson" })),
                            React.createElement(ButtonRouterLink, { primary: true, to: ADD_PEOPLE_MULTIPLE },
                                React.createElement(FormattedMessage, { id: "admin.manageUsers.button.addMultiplePeople" })))),
                    React.createElement(UserListData, { ref: this.userList, filterOptions: FILTER_OPTIONS, teamId: null }, function (_a) {
                        var users = _a.users, variables = _a.variables;
                        return (React.createElement(React.Fragment, null,
                            React.createElement(UserList, { variables: variables, employees: users.results, teams: teams, selectedEmployees: selectedEmployees, onToggle: _this.toggleSelectedUsers, onUpdate: _this.handleAddPeopleSubmit }),
                            selectedEmployees.length > 0 && (React.createElement(ManageUsersBottomBar, { variables: variables, selectedEmployees: selectedEmployees, onSave: _this.handleActivationStatusChange }))));
                    })))));
    };
    return ManageUsers;
}(React.PureComponent));
export { ManageUsers };
export default ManageUsers;
